import { defineMessages } from '@atlassian/jira-intl';
import type { Metric } from './EntityKey.types.tsx';

const messages = defineMessages({
	nameNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.name-non-final',
		defaultMessage: 'Work types',
		description:
			'Name of the site optimizer metric that will be used as the title on the page and menu item.',
	},
	descriptionNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.description-non-final',
		defaultMessage:
			'Monitor work types usage across projects. Each project can have up to {entityLimit} work types within a work type scheme. Monitor usage to stay within this threshold and maintain site performance and stability.',
		description: 'Description of the site optimizer metric.',
	},
	chartNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.chart-non-final',
		defaultMessage: 'Overview',
		description: 'A tab label of Work Type Tabs, to show work types chart',
	},
	reviewAndAnalyzeNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.review-and-analyze-non-final',
		defaultMessage: 'Analysis',
		description: 'A tab label of Work Type Tabs, to show work types review and analyze',
	},
	warningNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.warning-non-final',
		defaultMessage: 'The number of work types is nearing our recommended threshold.',
		description: 'Warning message if metric are getting close to the threshold.',
	},
	exceededNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.exceeded-non-final',
		defaultMessage: 'There are more work types than our recommended threshold.',
		description: 'Message to show to the user if metric has exceeded the threshold.',
	},
	risk1NonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.risk-1-non-final',
		defaultMessage:
			'Work types can make searching for issues (JQL and boards) and creating issues slow.',
		description: 'One of the risks when this metric exceeded the threshold.',
	},
	mitigation1NonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.mitigation-1-non-final',
		defaultMessage:
			'Edit the context for the work type to make it visible only for specific projects.',
		description: 'One of the mitigation options when this metric exceeded the threshold.',
	},
	mitigation2NonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.mitigation-2-non-final',
		defaultMessage:
			'Limit the number of work types across all projects and use the same work type in multiple projects.',
		description: 'One of the mitigation options when this metric exceeded the threshold.',
	},
	currentValueLabelNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.current-value-label-non-final',
		defaultMessage: 'Work types in your site',
		description: 'Label to be shown next to the current value of the metric.',
	},
	thresholdValueLabelNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.threshold-value-label-non-final',
		defaultMessage: 'Recommended maximum number of work types',
		description: 'Label to be shown next to the threshold value of the metric.',
	},
	currentValueAriaLabelNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.current-value-aria-label-non-final',
		defaultMessage: '{number} work types in your site',
		description: 'Aria Label for the current value',
	},
	thresholdValueAriaLabelNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.threshold-value-aria-label-non-final',
		defaultMessage: '{number} recommended maximum number of work types',
		description: 'Aria Label for the threshold value',
	},
	recommendationUrlTextNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.recommendation-url-text-non-final',
		defaultMessage: 'See how we identify these work types.',
		description: 'Text to be shown on the hypertext link to additional documentation.',
	},
	graphHeaderNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.graph-header-non-final',
		defaultMessage: 'Work types over time',
		description: 'Text to be shown on the header of the metric graph.',
	},
	risk1IssueTermRefreshNonFinal: {
		id: 'admin-pages__performance.common.assets.work-types.risk-1-issue-term-refresh-non-final',
		defaultMessage: 'Work types can make searching (JQL and boards) and creating work items slow.',
		description: 'One of the risks when this metric exceeded the threshold.',
	},
});

export const WORK_TYPES_KEY = 'worktype';

export const workTypesConstants: Metric = {
	key: WORK_TYPES_KEY,
	visible: true,
	name: messages.nameNonFinal,
	description: messages.descriptionNonFinal,
	tabLabels: [messages.chartNonFinal, messages.reviewAndAnalyzeNonFinal],
	warningMessage: messages.warningNonFinal,
	exceededMessage: messages.exceededNonFinal,
	risks: [messages.risk1NonFinal],
	mitigations: [],
	currentValueLabel: messages.currentValueLabelNonFinal,
	currentValueAriaLabel: messages.currentValueAriaLabelNonFinal,
	thresholdValueLabel: messages.thresholdValueLabelNonFinal,
	thresholdValueAriaLabel: messages.thresholdValueAriaLabelNonFinal,
	recommendationUrl: '',
	recommendationUrlText: messages.recommendationUrlTextNonFinal,
	graphHeader: messages.graphHeaderNonFinal,
};
